import React, { useEffect } from 'react'
import { Avatar, FormInstance, Select } from 'antd'
import { useGetAllTeamsOfOneOrganization } from 'api/Team/Team'
import Spinner from 'components/Spinner'
import { TeamType } from 'types/team/team'
import { getNameSignature } from 'helper/utility'

interface TeamSelectProps {
  form: FormInstance
  data: string | undefined
  organizationId: string
}

const TeamSelect: React.FC<TeamSelectProps> = ({
  form,
  data,
  organizationId,
}) => {
  const {
    isLoading,
    isFetching,
    refetch,
    isError,
    data: teamListing,
  } = useGetAllTeamsOfOneOrganization(organizationId)

  useEffect(() => {
    refetch()
  }, [organizationId])

  return (
    <div>
      <Select
        className="h-50px select-field"
        placeholder={'Select Team'}
        defaultValue={data}
        onChange={(v, item: { value: string; key: string }) => {
          form.setFieldsValue({
            teamId: item.value,
          })
        }}
      >
        {isLoading || isFetching ? (
          <div className="py-40px">
            <Spinner />
          </div>
        ) : isError ? (
          <div className="py-40px flex justify-center align-center">
            <p>Something went wrong while loading teams</p>
          </div>
        ) : (
          teamListing.map((team: TeamType) => (
            <Select.Option key={team._id} value={team._id}>
              <div className="flex align-center gap-10px">
                <Avatar size={20} src={team.profilePhoto?.thumb}>
                  {getNameSignature(team.name)}
                </Avatar>
                <p className="text-14 w-600">{team.name}</p>
              </div>
            </Select.Option>
          ))
        )}
      </Select>
    </div>
  )
}

export default TeamSelect
